import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/classroom.png'


const _hoisted_1 = { class: "flex items-center space-x-2 mb-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"25px"}
}, null, -1)
const _hoisted_3 = { class: "" }
const _hoisted_4 = {
  key: 0,
  style: {"display":"-webkit-box","-webkit-line-clamp":"2","-webkit-box-orient":"vertical","overflow":"hidden"},
  class: "mb-2 -mt-4"
}
const _hoisted_5 = { class: "overflow-hidden overflow-ellipsis mb-4" }
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 1,
  class: "flex w-full mt-auto"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg material-icons-outlined" }, " done ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{
			'outline-success outline-4 border-transparent': _ctx.selected,
			'hover:border-transparent hover-shadow-elevation hover:bg-light': _ctx.hoverable,
		}, "card card-border card-hoverable duration-75 ease-in-out transition-all flex flex-col"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.course.name), 1)
    ]),
    (_ctx.course.description)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.course.description), 1))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_5, [
      _createElementVNode("a", {
        href: _ctx.course.alternateLink,
        target: "_blank"
      }, _toDisplayString(_ctx.course.alternateLink), 9, _hoisted_6)
    ]),
    (_ctx.selectable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_Btn, {
            class: _normalizeClass(["ml-auto -mr-1 -mb-1", { 'icon-btn-success': _ctx.selected }]),
            variant: 'icon',
            outline: true,
            tooltip: _ctx.$t('misc.select'),
            forceActive: _ctx.selected,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('courseSelected')))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["tooltip", "forceActive", "class"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}